export const dspFeatures = ['chroma', 'chord', 'rms', 'tuner'] as const
export type DSPFeatureName = (typeof dspFeatures)[number]
